export const MUI_SPACING = 8;
export const MUI_BORDER_RADIUS = 4;
export const twBorders: Record<number, string> = {
  1: 'border',
  2: 'border-2',
  4: 'border-4',
  8: 'border-8',
};
export const twBorderRadius: Record<string, string> = {
  0: 'rounded-none',
  0.5: 'rounded-xs',
  1: 'rounded-sm',
  1.5: 'rounded-md',
  2: 'rounded-lg',
  3: 'rounded-xl',
  4: 'rounded-2xl',
};
export const twShadows: Record<string, string> = {
  0: 'shadow-none',
  1: 'shadow-xs',
  2: 'shadow-sm',
  3: 'shadow-md',
  4: 'shadow-lg',
  5: 'shadow-xl',
  6: 'shadow-2xl',
};
export const twZIndex: Record<string, string> = {
  fab: 'z-1050',
  appBar: 'z-1100',
  drawer: 'z-1200',
  modal: 'z-1300',
  snackbar: 'z-1400',
  tooltip: 'z-1500',
};

export const twDisplay: Record<string, string> = {
  none: 'hidden',
  block: 'block',
  inline: 'inline',
  'inline-block': 'inline-block',
  flex: 'flex',
  'inline-flex': 'inline-flex',
  grid: 'grid',
  'inline-grid': 'inline-grid',
  contents: 'contents',
  'flow-root': 'flow-root',
  'list-item': 'list-item',
  table: 'table',
  'table-row': 'table-row',
  'table-cell': 'table-cell',
};

export const twFlex: Record<string | number, string> = {
  1: 'flex-1',
  auto: 'flex-auto',
  initial: 'flex-initial',
  none: 'flex-none',
};

export const twOverflow: Record<string, string> = {
  auto: 'overflow-auto',
  hidden: 'overflow-hidden',
  clip: 'overflow-clip',
  visible: 'overflow-visible',
  scroll: 'overflow-scroll',
};
